/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF } from "@react-three/drei";


export function SneakerBauhaus(props) {

  const { nodes, materials } = useGLTF("./models/NikeAirMaxBauhaus.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NikeAirMax.geometry}
        material={materials.NikeAirMax}
        position={[-0.026, 0.044, 0.028]}
      />
    </group>
  );
}

export function SneakerGreen(props) {

  const { nodes, materials } = useGLTF("./models/NikeAirMaxGreen.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NikeAirMax.geometry}
        material={materials.NikeAirMax}
        position={[-0.026, 0.044, 0.028]}
      />
    </group>
  );
}

export function SneakerWoman(props) {

  const { nodes, materials } = useGLTF("./models/NikeAirMaxWoman.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NikeAirMax.geometry}
        material={materials.NikeAirMax}
        position={[-0.026, 0.044, 0.028]}
      />
    </group>
  );
}

export function SneakerBlue(props) {

  const { nodes, materials } = useGLTF("./models/NikeAirMaxBlue.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NikeAirMax.geometry}
        material={materials.NikeAirMax}
        position={[-0.026, 0.044, 0.028]}
      />
    </group>
  );
}

export function SneakerWhite(props) {

  const { nodes, materials } = useGLTF("./models/NikeAirMaxWhite.glb");

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.NikeAirMax.geometry}
        material={materials.NikeAirMax}
        position={[-0.026, 0.044, 0.028]}
      />
    </group>
  );
}

// useGLTF.preload("./models/NikeAirMaxBauhaus.glb");
// useGLTF.preload("./models/NikeAirMaxGreen.glb");
// useGLTF.preload("./models/NikeAirMaxWoman.glb");
// useGLTF.preload("./models/NikeAirMaxBlue.glb");
// useGLTF.preload("./models/NikeAirMaxWhite.glb");
